import Spacer from "../../components/Spacer";
import ScoreTag from "../../components/ScoreTag";
import React, {useState} from "react";
import {Alert, Space} from "antd";
import {pp} from "../../utils";
import {observer} from "mobx-react";
import PlayerNameLink from "./PlayerNameLink";
import FakeTable from "@/components/FakeTable.js";
import BottomSideDrawer from "@/components/BottomSideDrawer.js";
import MobileTitle from "@/components/MobileTitle.js";
import {Switch2} from "@/components/Switcher.js";

// TODO: This was for flex league contacts. Can change just to player name link.
let nameWithContact = pl => {
  return <PlayerNameLink pl={pl} withStats={!!gon.tournament} />;
}

let teamNames = (m, t1, teamById) => {
  let g = m.games[0];
  let won = m[t1 ? "t1w" : "t2w"] > m[t1 ? "t2w" : "t1w"];
  let style = {
    // color: won && "green",
    fontWeight: won && "bold"
  }

  if (m.games.length === 5) {
    return <div style={style}>
      <div>{teamById[t1 ? m.t1_id : m.t2_id].name}</div>
    </div>
  }

  if (g.players.length === 4)
    return <div style={style}>
      <div>{nameWithContact(g.players[t1 ? 0 : 2])}</div>
      <div>{nameWithContact(g.players[t1 ? 1 : 3])}</div>
      {/*<div>{g.players[t1 ? 0 : 2].name}</div>*/}
      {/*<div>{g.players[t1 ? 1 : 3].name}</div>*/}
    </div>

  if (g.players.length === 2)
    return <div style={style}>
      <div>{nameWithContact(g.players[t1 ? 0 : 1])}</div>
    </div>
}

let scoreTagList = (m, t, total, onClick) => {
  let games = _.filter(m.games, g => _.isNumber(g.t1p));
  let ot = t === "t1" ? "t2" : "t1";

  if (total)
    if (games.length >= 3)
      return <ScoreTag v={m[t+"w"]} type={m[t+"w"] > m[ot+"w"] ? 'win' : 'lose'} w="35px" onClick={onClick}/>
    else
      return null;

  return <Space>
    {games.map(g => {
      let v = g[t+"p"];
      let isWithdraw = g.status === (ot + "_withdraw");
      let isForfeit = g.status === (t + "_forfeit");
      if (isForfeit)
        v = "F"+(v || "");

      return <ScoreTag key={g.id} v={v} type={(g[t+"p"] > g[ot+"p"]  || isWithdraw) ? 'win' : 'lose'} w="35px" onClick={onClick}/>
    })}
  </Space>
}

let Pmatch = observer(({pm, teams, mi}) => {
  let {scores, player_ids} = pm;

  let pidToName = (ti, id) => <div>{_.find(teams[ti].players, {id})?.name}</div>

  let gamesWinners = scores.map(sa => sa[0] > sa[1] ? 0 : 1);

  return <div>
    <MobileTitle title={"Match " + (mi)} />
    <FakeTable small>
      <tr>
        <td style={{width: "200px"}}>
          {pidToName(0, player_ids[0])}
          {pidToName(0, player_ids[1])}
        </td>
        {scores.map((sa, i) => <td key={i}>
          <div className="flex justify-end">
            {sa ? <ScoreTag v={sa[0]} type={gamesWinners[i] === 0 ? 'win' : 'lose'} w="35px" /> : null}
          </div>
        </td>)}
      </tr>
      <tr>
        <td style={{width: "200px"}}>
          {pidToName(1, player_ids[2])}
          {pidToName(1, player_ids[3])}
        </td>
        {scores.map((sa, i) => <td key={i}>
          <div className="flex justify-end">
            {sa ? <ScoreTag v={sa[1]} type={gamesWinners[i] === 1 ? 'win' : 'lose'} w="35px" /> : null}
          </div>
        </td>)}
      </tr>
    </FakeTable>
  </div>
});

let TeamName = ({t}) => {
  return <Switch2 v={t.name}>
    <div>{t.name}</div>
    {t.players.map(p => <div key={p.id}>{p.name}</div>)}
  </Switch2>
}

let pmatchHasScores = (pm) => {
  return pm.scores?.some(sa => _.compact(sa).length > 0);
}

export let MatchDrawerContent = observer(({m}) => {
  let rs = m.results;
  return <Switch2 v={rs[0]?.type === "unknown"}>
    <Alert message="Waiting for Results" type="warning" />
    <div style={{backgroundColor: "#f1f5f9"}}>
      {m.pmatches.filter(pmatchHasScores).map((pm, i) => <Pmatch key={pm.id} pm={pm} teams={m.teams} mi={i+1} />)}
    </div>
  </Switch2>
});

let MatchOverview = observer(({m}) => {
  const [show, setShow] = useState(false);

  let rs = m.results;

  let onClick = () => setShow(!show);

  let teamView = i => {
    let t = m.teams[i];
    return <Spacer
      l={<div className={rs[i].type === "win" && "font-bold"}><TeamName t={t} /></div>}
      r={<ScoreTag v={rs[i].points} type={rs[i].type} w="35px" onClick={onClick} />}
    />
  }

  return <div>
    <BottomSideDrawer show={show} onClose={() => setShow(false)} title={"Match #" + m.mid}>
      <MatchDrawerContent m={m} />
    </BottomSideDrawer>
    <div className="space-y-2 cursor-pointer" onClick={onClick}>
      {teamView(0)}
      <hr/>
      {teamView(1)}
    </div>
  </div>
});

let MatchScorecard = observer(({m, teamById, total, onClick}) => {
  if (m.results)
    return <MatchOverview m={m}/>

  return <div className="space-y-2">
    <Spacer l={teamNames(m, true, teamById)} r={scoreTagList(m, "t1", total, onClick)} />
    <hr/>
    <Spacer l={teamNames(m, false, teamById)} r={scoreTagList(m, "t2", total, onClick)} />
  </div>
});

export default MatchScorecard